import * as Yup from "yup";

/** Volunteer gender categories — keep in sync with sva-api config/datahub.php */
export const GENDER_CATEGORIES = [
  "Male",
  "Female",
  "Non-binary",
  "Prefer to self-describe",
  "Prefer not to say",
];

export const genderYupRule = () =>
  Yup.string()
    .required("Please select a gender")
    .oneOf(GENDER_CATEGORIES, "Please select a valid gender option");
